import { ScrollPanel } from 'primereact/scrollpanel';
import React, { useRef, useState } from 'react';
import { FileUpload } from 'primereact/fileupload';
import './Docupload.styles.css';
import uploadImg from "../../assets/images/uploadicon.svg";
import { ImageConfig } from '../../utils/ImageConfig';
import TickIcon from "../../assets/images/tickIcon.svg"
import ViewDocUploaded from '../ViewDocUploaded';

interface DropFileInputProps {
    onFileUpload: (files: File[]) => void;
    filesInfo: any;
    disabled: boolean;
    visible: boolean;
    sidebyside?: boolean;
    isFolderPath: boolean;
    isDocSuccess: boolean;
    isDocFail: boolean;
}

const Docupload: React.FC<DropFileInputProps> = ({ filesInfo, disabled, visible, sidebyside= false, isFolderPath, isDocSuccess, isDocFail, onFileUpload }) => {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const [fileList, setFileList] = useState<File[]>([]);
    const [showViewDocModal, setShowViewDocModal] = useState<boolean>(false);
    const onDragEnter = () => wrapperRef.current?.classList.add('dragover');
    const onDragLeave = () => wrapperRef.current?.classList.remove('dragover');
    const onDrop = () => wrapperRef.current?.classList.remove('dragover');

    const onFileDrop = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newFiles = Array.from(e.target.files || []);
        setFileList(newFiles);
        onFileUpload(newFiles);
    }

    const fileRemove = (file: File) => {
        const updatedList = fileList.filter(item => item !== file);
        setFileList(updatedList);
        // onFileChange(updatedList);
    }

    const downloadFile = (file: File) => {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    return (
        <div className='row'>
            <p className='upload-doc-header'>Documentation Upload</p>
            <div className={`${sidebyside ? "col-6" : 'col-12'}`}>
            {!isDocSuccess && !isDocFail ? 
                <div
                    ref={wrapperRef}
                    className="drop-file-input"
                    onDragEnter={onDragEnter}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}
                >
                    <div className="d-flex align-items-center drop-file-input__label">
                        <img src={uploadImg} alt="Upload" />
                        <div>
                            <h2>Select documents to upload or drag & drop</h2>
                            <h4>Supported file types: pdf, txt, doc, xls</h4>
                        </div>
                    </div>
                    <input
                         type="file"
                         onChange={onFileDrop}
                         multiple
                         style={{
                           opacity: 0,
                           position: "absolute",
                           top: 0,
                           left: 0,
                           width: "100%",
                           height: "100%",
                           cursor: disabled ? "not-allowed" : "pointer",
                         }}
                         disabled={disabled}
                    />
                </div>
            : <></>}

            {isDocSuccess &&
                <div className="drop-file-input">
                    <div className="doc-status-content">
                        <svg width="100" height="100">
                            <circle
                                fill="none"
                                stroke="#78A22F"
                                stroke-width="5"
                                cx="50"
                                cy="50"
                                r="45"
                                strokeLinecap="round"
                                transform="rotate(-40 50 50)"
                                className="doc-status-circle"
                            />
                            <polyline
                                fill="none"
                                stroke="#78A22F"
                                points="20,53 45,73 80,36"
                                strokeWidth="5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="doc-status-tick"
                            />
                        </svg>
                        <p className="doc-status-tick-text">Document Uploaded Successfully.</p>
                    </div>
                </div>
            }

            {isDocFail &&
                <div className="drop-file-input">
                    <div className="doc-status-content">
                        <svg width="100" height="100">
                            <circle
                                fill="none"
                                stroke="#C43131"
                                stroke-width="5"
                                cx="50"
                                cy="50"
                                r="45"
                                strokeLinecap="round"
                                transform="rotate(-40 50 50)"
                                className="doc-status-circle"
                            />
                            <path
                                fill="none"
                                stroke="#C43131"
                                stroke-width="6"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M 25,25 L 75,75 M 75,25 L 25,75"
                                className="doc-status-cross"
                            />
                        </svg>
                        <p className="doc-status-cross-text">Document Uploaded Failed, Please Try Again.</p>
                    </div>
                </div>
            }
            </div>

            <div className={`${sidebyside ? "col-6" : 'col-12'}`}>
            {filesInfo?.files && filesInfo?.files.length > 0 ? (
                <div className='car-upload-file-container'>
                    <div className="drop-file-preview">
                        {filesInfo.files.map((item: any, index: number) => (
                            // onClick={() => setShowViewDocModal(true)}
                            <div key={index} className="drop-file-preview__item">
                                <img
                                    src={ImageConfig[item.split('/')[1]] || ImageConfig['default']}
                                    alt={item}
                                />
                                <div className="drop-file-preview__item__info">
                                    <span style={{ textAlign: "justify", fontSize: "10px", fontWeight: 500, width: "100px" }}>{item}</span>
                                    <span style={{ textAlign: "justify", fontSize: "8px", fontWeight: 400 }}>Uploaded</span>
                                </div>
                                <div>
                                    
                                </div>
                                <span
                                    className="drop-file-preview__item__del"
                                //onClick={() => fileRemove(item)}
                                >
                                    x
                                </span>
                                <span
                                    className="drop-file-preview__item__download"
                                // onClick={() => downloadFile(item)}
                                >
                                    <i className='bi bi-download'></i>
                                </span>
                                <img className='doc-success-tick-icon' src={TickIcon} alt={''} />
                            </div>
                        ))}
                       
                    </div>

                </div>
            ) : (
                <>
                    <div className='file-upload-empty'>
                        <p className='file-upload-main-empty'>There are no uploaded files.</p>
                        {!isFolderPath &&
                            <p className='file-upload-sub-empty'>File Upload Path Not Available.</p>
                        }
                    </div>

                </>
            )}
             </div>
             <ViewDocUploaded  show={showViewDocModal} setShow={setShowViewDocModal} document={''}  />
        </div>
    );
}

export default Docupload;
